import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { determineFilterStoreScope } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getSelectedDimension } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getPrimaryFilterFullKey } from 'libs/end-to-end/src/filters-v2/filter-utils';
import React, { useMemo } from 'react';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { FilterMenuSinglePanel } from 'apps/sigma2-ui/src/filters-v2/components/FilterMenuSinglePanel';
import { FilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import orderBy from 'lodash/orderBy';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DimensionMenu = ({
  allDimensions,
  store,
  feature,
  databaseRevisionId,
  databaseId,
  organizationId,
  closeMenu,
  setPrimaryFilters,
  focusArea,
  analysisName,
}: {
  allDimensions: DimensionDefinition[];
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  closeMenu: () => void;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  focusArea: FocusArea | null;
  analysisName: string | undefined;
}) => {
  const language = useLanguage();
  const items = useMemo(() => {
    const currentDimension = getSelectedDimension({
      feature,
      organizationId,
      databaseRevisionId,
      databaseId,
      store,
      focusArea,
      analysisName,
    });

    const fullKey = getPrimaryFilterFullKey({
      primaryFilterKey: 'dimension',
    });

    const scope = determineFilterStoreScope({
      feature,
      fullKey,
      databaseId,
      databaseRevisionId,
      organizationId,
      focusArea,
      analysisName,
    });

    if (!scope) {
      return [];
    }

    return allDimensions.map((dimension) => ({
      value: dimension.columnHeaderValue,
      translatedContent: language.dimensionDisplayName({
        definition: dimension,
      }),
      selected: dimension.columnHeaderValue === currentDimension,
    }));
  }, [
    feature,
    organizationId,
    databaseRevisionId,
    databaseId,
    store,
    focusArea,
    analysisName,
    allDimensions,
    language,
  ]);

  return (
    <FilterMenuSinglePanel
      filterContent={
        <FilterListBox
          multiple={false}
          items={items}
          onUpdate={({ addedSelections }) => {
            const newDimension = allDimensions.find(
              (d) => d.columnHeaderValue === addedSelections[0],
            );
            const levels = orderBy(
              newDimension?.levels ?? [],
              ['isPrivileged'],
              ['desc'],
            );

            const primaryFiltersSelections: PrimaryFilterSelection[] = [
              {
                primaryFilterKey: 'dimension',
                value: addedSelections[0],
              },
            ];

            if (feature === 'progressPage') {
              primaryFiltersSelections.push({
                primaryFilterKey: 'comparisonGroup',
                value: levels[0].columnValue,
              });
            }

            setPrimaryFilters({ selections: primaryFiltersSelections });

            closeMenu();
          }}
        />
      }
      bottomProps={'none'}
    />
  );
};
